export enum DropdownButtonTypeEnum {
  CART_CARD_VARIANT = 'CART_CARD_VARIANT',
  CART_CARD_MOBILE_VARIANT = 'CART_CARD_MOBILE_VARIANT',
  CHECKOUT = 'CHECKOUT',
  PRODUCT_MERCHANDISE = 'PRODUCT_MERCHANDISE',
  PRODUCT_CARD = 'PRODUCT_CARD',
}
